import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f626a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basket-line-item-column-image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "basket-line-item-columns-right-outer-wrap" }
const _hoisted_4 = { class: "basket-line-item-column-description" }
const _hoisted_5 = { class: "basket-line-item-column-quantity" }
const _hoisted_6 = { class: "basket-line-item-column-price" }
const _hoisted_7 = { class: "basket-line-item-column-up-sell" }
const _hoisted_8 = { class: "basket-line-item-column-up-sell" }

import { DeliverableType, ModuleConfigurationProductItem } from '@/b2c/shared/api/server-apis';
import BasketLineItemQuantity from '@/b2c/basket/ui/line-items/parts/BasketLineItemQuantity.vue';
import BasketLineItemRemove from '@/b2c/basket/ui/line-items/parts/BasketLineItemRemove.vue';
import BasketLineItemPrice from '@/b2c/basket/ui/line-items/parts/BasketLineItemPrice.vue';
import BasketLineItemSpecs from '@/b2c/basket/ui/line-items/parts/BasketLineItemSpecs.vue';
import BasketLineItemColliInfo from '@/b2c/basket/ui/line-items/parts/BasketLineItemColliInfo.vue';
import BasketLineItemTitle from '@/b2c/basket/ui/line-items/parts/BasketLineItemTitle.vue';
import ItemMessages from '@/b2c/shared/checkout/ui/ItemMessages.vue';
import BasketLineItemLabel from '@/b2c/basket/ui/line-items/parts/BasketLineItemLabel.vue';
import BasketLineItemUpSell from '@/b2c/basket/ui/line-items/parts/BasketLineItemUpSell.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useCustomerDeliveryMessages } from '@/b2c/basket/useCustomerDeliveryMessages';
import BasketLineItemModuleList from '@/b2c/basket/ui/line-items/parts/BasketLineItemModuleList.vue';
import BasketLineItemEditModuleConfiguration from '@/b2c/basket/ui/line-items/parts/BasketLineItemEditModuleConfiguration.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemModuleConfiguration',
  props: {
    item: null,
    deliverableType: null
  },
  setup(__props: any) {

const props = __props as {
    item: ModuleConfigurationProductItem;
    deliverableType: DeliverableType;
}

const labels = useBlockLabels();

const { deliveryMessage } = useCustomerDeliveryMessages(props.item.id);

return (_ctx: any,_cache: any) => {
  const _component_Breakpoints = _resolveComponent("Breakpoints")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass({ 'basket-line-item-row--discontinued': __props.item.isSoldOut || __props.item.isDiscontinued })
  }, [
    (__props.item.isDiscontinued)
      ? (_openBlock(), _createBlock(BasketLineItemLabel, {
          key: 0,
          label: _unref(labels).lineItemDiscontinuedLabel,
          class: "absolute z-1"
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.item.image,
        class: "w-full"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BasketLineItemTitle, {
          title: __props.item.name,
          sku: __props.item.modules[0].sku,
          "configuration-guid": __props.item.moduleReferenceId,
          "edit-guid": __props.item.uniqueIdentifier
        }, null, 8, ["title", "sku", "configuration-guid", "edit-guid"]),
        (__props.item.quantityMultiplier > 0)
          ? (_openBlock(), _createBlock(BasketLineItemColliInfo, {
              key: 0,
              multiplier: __props.item.quantityMultiplier
            }, null, 8, ["multiplier"]))
          : _createCommentVNode("", true),
        (__props.item.specifications)
          ? (_openBlock(), _createBlock(BasketLineItemSpecs, {
              key: 1,
              specs: __props.item.specifications
            }, null, 8, ["specs"]))
          : _createCommentVNode("", true),
        (__props.item.modules[0].specifications)
          ? (_openBlock(), _createBlock(BasketLineItemSpecs, {
              key: 2,
              specs: __props.item.modules[0].specifications
            }, null, 8, ["specs"]))
          : _createCommentVNode("", true),
        _createVNode(BasketLineItemEditModuleConfiguration, {
          sku: __props.item.modules[0].sku,
          "configuration-guid": __props.item.moduleReferenceId,
          "edit-guid": __props.item.uniqueIdentifier
        }, null, 8, ["sku", "configuration-guid", "edit-guid"]),
        _createVNode(ItemMessages, {
          messages: __props.item.secondaryItemMessages,
          class: "basket-line-item-messages"
        }, null, 8, ["messages"]),
        _createVNode(ItemMessages, {
          messages: _unref(deliveryMessage),
          class: "basket-line-item-messages"
        }, null, 8, ["messages"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!__props.item.isSoldOut && !__props.item.isDiscontinued)
          ? (_openBlock(), _createBlock(BasketLineItemQuantity, {
              key: 0,
              id: __props.item.id,
              quantity: __props.item.quantity,
              multiplier: __props.item.quantityMultiplier
            }, null, 8, ["id", "quantity", "multiplier"]))
          : _createCommentVNode("", true),
        _createVNode(BasketLineItemRemove, {
          id: __props.item.id
        }, null, 8, ["id"]),
        _createVNode(ItemMessages, {
          messages: __props.item.primaryItemMessages,
          class: "basket-line-item-messages"
        }, null, 8, ["messages"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BasketLineItemPrice, {
          price: __props.item.price,
          quantity: __props.item.quantity
        }, null, 8, ["price", "quantity"])
      ]),
      _createVNode(BasketLineItemModuleList, {
        modules: __props.item.modules
      }, null, 8, ["modules"]),
      _createVNode(_component_Breakpoints, null, {
        "min-sm": _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BasketLineItemUpSell, {
              "item-id": __props.item.id,
              "deliverable-type": __props.deliverableType
            }, null, 8, ["item-id", "deliverable-type"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Breakpoints, null, {
      "max-xs": _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BasketLineItemUpSell, {
            "item-id": __props.item.id,
            "deliverable-type": __props.deliverableType
          }, null, 8, ["item-id", "deliverable-type"])
        ])
      ]),
      _: 1
    })
  ], 2))
}
}

})